export default __webpack_public_path__ + "static/media/NW0060.34I-30316_-17520_0.d64e3ea1.jpg";